import { render } from "./Sale_Fees.vue?vue&type=template&id=cfd7986e"
import script from "./Sale_Fees.vue?vue&type=script&lang=js"
export * from "./Sale_Fees.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__